module.exports = __webpack_public_path__ + "static/media/1-8.379b01da.webp";